const APP_STORE_MESSAGE_EXTENSION = 'b6b18421-3bba-40df-a983-05fbbc9e2d13';
const APP_STORE_LAUNCH_PAGE = 'f3a6e67f-850d-4dd9-960a-04c6638ded36';

export { APP_STORE_LAUNCH_PAGE, APP_STORE_MESSAGE_EXTENSION };
